import type { ProductCardV2EnergyEfficiencyFlagsProps } from './ProductCardV2.EnergyEfficiencyFlags.client';
import type { ProductCardV2EnergyEfficiencyFlagsLegacyProps } from './ProductCardV2.EnergyEfficiencyFlagsLegacy';
import type { ProductCardV2TireEfficiencyFlagsProps } from './ProductCardV2.TireEfficiencyFlags.client';

import { ProductCardV2EnergyEfficiencyFlags } from './ProductCardV2.EnergyEfficiencyFlags.client';
import { ProductCardV2EnergyEfficiencyFlagsLegacy } from './ProductCardV2.EnergyEfficiencyFlagsLegacy';
import { ProductCardV2TireEfficiencyFlags } from './ProductCardV2.TireEfficiencyFlags.client';
import { ProductCardV2EfficiencyFlagsContainer } from './ProductCardV2.EfficiencyFlagsContainer';

export type ProductCardV2EfficiencyFlagsProps = {
  /** Optional className for the container. */
  className?: string;
  /** Energy efficiency flags, each with its own optional datasheet. Used by the search cards. */
  energyFlags?: ProductCardV2EnergyEfficiencyFlagsProps['flags'];
  /** Tire efficiency flags. Used by the search cards. */
  tireFlags?: ProductCardV2TireEfficiencyFlagsProps['flags'];
  /** Combined energy/tire flags sharing one datasheet column. Used by the reco card. */
  legacyFlags?: ProductCardV2EnergyEfficiencyFlagsLegacyProps;
};

/**
 * Efficiency flags block shared by the product cards.
 *
 * Search and SPA cards pass `energyFlags`/`tireFlags`; the reco card passes `legacyFlags`.
 * The container renders when at least one of them has entries, and nothing at all otherwise.
 */
export const ProductCardV2EfficiencyFlags = ({
  className,
  energyFlags,
  tireFlags,
  legacyFlags,
}: ProductCardV2EfficiencyFlagsProps) => {
  const hasEnergy = !!energyFlags?.length;
  const hasLegacy = !!legacyFlags?.flags.length;
  const hasTire = !!tireFlags?.length;

  if (!hasEnergy && !hasLegacy && !hasTire) return null;

  return (
    <ProductCardV2EfficiencyFlagsContainer className={className}>
      {hasEnergy && <ProductCardV2EnergyEfficiencyFlags flags={energyFlags} />}
      {hasLegacy && <ProductCardV2EnergyEfficiencyFlagsLegacy {...legacyFlags} />}
      {hasTire && <ProductCardV2TireEfficiencyFlags flags={tireFlags} />}
    </ProductCardV2EfficiencyFlagsContainer>
  );
};
